module.exports = __webpack_public_path__ + "static/img/sec1-slide-img03@t.4ee88e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/transys/sec1-slide-img03@t.jpg
// module id = AH2B
// module chunks = 0